// ----------------------------------------------------
// src/Redux/Slices/PurposeSlice.js
// ----------------------------------------------------

import { createSlice } from "@reduxjs/toolkit";
import purposeData from "../../Json/PurposeData.json";

const initialState = {
  purpose: purposeData,
};

const PurposeSlice = createSlice({
  name: "purpose",
  initialState,
  reducers: {},
});

export default PurposeSlice.reducer;